<template>
  <div>
    <draggable class="inner" :list="items" group="order"   
        @start="startDrag()"
        @end="endDrag()"
        :ref="name"
        :id="name">
        <div v-for="(item, index) in items" :key="index" class="item" :data-id="item.id">
            <template v-for="(field, index) in fields">
              <p v-text="item[field.model]" :key="`display-${index}`"></p>
            </template>
            <v-btn @click="remove(index)"><v-icon>mdi-close-circle</v-icon></v-btn>
        </div>
    </draggable>

    <component :is="field.component" v-model="item[field.model]" :label="field.label" :items="field.items" v-for="(field, index) in fields" :key="`field-${index}`" @change="change($event)" item-text="title" item-value="id"/>

    
    <v-btn @click="add" :diabled="!selectedId">Add item</v-btn>

  </div>
</template>

<script>
// @ is an alias to /src
const fb = require("@/firebaseConfig.js");
import {VTextField, VSelect} from 'vuetify/lib'
import draggable from "vuedraggable";
export default {
  name: "OrderedItems",
  data() {
    return {
      items: this.value,
      refs: null,
      fields: [],
      item: {},
      selectedId: null,
    }
  },
  props: {
    value: Array,
    name: String,
    collection: String
  },
  components: {
    draggable,
  },
  watch: {
    value: {
      handler: function (val) {
        this.items = val
      },
      deep: true
    }
  },
  mounted() {
    if (this.collection) {
      this.getRefs();
    }
  },
  methods: {
    populateField(field) {
      return field ? field : null
    },
    add() {
      if (this.selectedId) {
      let selected = this.refs.find(x => x.id == this.selectedId); 
      let item = {
        index : this.items.length,
        title: this.populateField(selected.title),
        slug: this.populateField(selected.slug),
        id: this.selectedId,
      }
      this.items.push(item);
      this.selectedId = null;
      }
    },
    change(ev) {
      // this.item[ev.model] = val
      this.selectedId = ev;
    },
    remove(index) {
      this.items.splice(index, 1);
    },
    startDrag() {
      this.dragging = true;
    },
    endDrag() {
      let count = 0;
      let vm = this;
      let div = document.getElementById(this.name);
      div.children.forEach((doc) => {
        let item = this.items.find((x) => x.id == doc.dataset.id);
        console.log(item)
        let indexOfItem = this.items.indexOf(item);
        item.index = count;
        vm.$set(vm.items, indexOfItem, item);
        count++;
      });
      this.dragging = false;
    },
    createFields() {
      console.log('create fields')
      this.fields = [
        {component : VTextField, model:'title', label: 'Title'},
        {component : VSelect, model:'benchmark', label: 'Bencmark', items: this.refs }
      ]
    },
    getRefs() {
       fb[this.collection]
        .get()
        .then((docs) => {
          let refs = [];
          docs.forEach((docs) => {
            let doc = docs.data();
            refs.push(doc);
          });
          this.refs = refs;
          this.createFields()
        })
        .catch(() => {});
    }
  }
};
</script>


<style lang="scss" scoped>
  .item {
    border: 1px solid white;
    padding: 1rem;
    display: flex;
    justify-content: space-between;
  }
</style>

